import React from 'react';
import clsx from 'clsx';

import RenderTextField, { RenderTextFieldProps } from 'shared/forms/render-text-field';

import { useStyles } from './styles';

export type DisabledVariant = 'default' | 'grey';

export type AuthInputFieldProps<T> = RenderTextFieldProps<T> & {
  disabledVariant?: DisabledVariant;
  bordered?: boolean;
};

export const AuthInputField = <T,>({
  InputProps,
  label,
  name,
  customLabel,
  disabledVariant = 'default',
  bordered = true,
  ...props
}: AuthInputFieldProps<T>) => {
  const classes = useStyles({ disabledVariant, bordered });

  return (
    <RenderTextField
      {...props}
      variant="standard"
      name={name}
      className={clsx(classes.authInputField, { [props?.className as string]: !!props?.className })}
      InputProps={{
        ...InputProps,
        classes: { input: classes.input, disabled: classes.disabled, underline: classes.underline },
      }}
      customLabel={
        customLabel ?? (
          <label htmlFor={name} className={classes.label}>
            {label}
          </label>
        )
      }
    />
  );
};
